import { Tooltip } from "@swivl-mono/ui";
import React from "react";
import { IoMdInformationCircleOutline } from "react-icons/io";

interface FieldLabelWithInfoProps {
  label: string;
  /** Explanation shown on hover or keyboard focus of the info icon. */
  tooltip: string;
}

/**
 * A field label followed by an info icon that explains the field on hover.
 * Used by the Location and Assignee fields, where the two are coupled: the
 * location decides which members can be assigned (ENG-2961).
 */
export function FieldLabelWithInfo({ label, tooltip }: FieldLabelWithInfoProps): React.JSX.Element {
  return (
    <span className="inline-flex items-center gap-1">
      {label}
      {/* `tabIndex` belongs on the Tooltip wrapper, which is what carries the
          hover and focus handlers; the icon itself is decorative. */}
      <Tooltip content={tooltip} tabIndex={0} classNames={{ wrapper: "cursor-help text-grey-600" }}>
        <IoMdInformationCircleOutline aria-hidden className="size-4 shrink-0" />
      </Tooltip>
    </span>
  );
}
